import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { cn } from '../lib/utils';

const facilityTypes = [
  {
    value: 'car',
    label: 'Light Vehicle',
    emoji: '🚗',
    description: 'Private cars, sedans, SUVs, and light vehicles',
  },
  {
    value: '3w',
    label: '3-Wheeler',
    emoji: '🛺',
    description: 'Auto-rickshaws and three-wheeled vehicles',
  },
  {
    value: 'truck',
    label: 'Truck',
    emoji: '🛻',
    description: 'Commercial trucks and heavy goods vehicles',
  },
  {
    value: 'bus',
    label: 'Bus',
    emoji: '🚌',
    description: 'Passenger buses and coaches',
  },
  {
    value: 'trailer',
    label: 'Trailer (CNG Tube)',
    emoji: '🚛',
    description: 'CNG tube trailers for gas transport',
  },
  {
    value: 'cng_storage',
    label: 'CNG Storage',
    emoji: '🏭',
    description: 'Fixed CNG storage facilities',
  },
];

export default function FacilityTypeSelector({ open, onOpenChange, onSelect }) {
  const handleSelect = (type) => {
    onSelect(type);
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-2xl">
        <DialogHeader>
          <DialogTitle className="text-xl">What type of facility are you inspecting?</DialogTitle>
          <DialogDescription>
            Select the facility type to begin the inspection process
          </DialogDescription>
        </DialogHeader>
        
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 py-4">
          {facilityTypes.map((type) => (
            <button
              key={type.value}
              onClick={() => handleSelect(type.value)}
              className={cn(
                "flex flex-col items-center p-4 rounded-xl border-2 transition-all duration-200",
                "hover:border-emerald-500 hover:bg-emerald-50 hover:shadow-md",
                "focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2",
                "group cursor-pointer"
              )}
              data-testid={`facility-type-${type.value}`}
            >
              <span className="text-4xl mb-3 group-hover:scale-110 transition-transform">
                {type.emoji}
              </span>
              <span className="font-semibold text-sm text-center mb-1">
                {type.label}
              </span>
              <span className="text-xs text-muted-foreground text-center line-clamp-2">
                {type.description}
              </span>
            </button>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export { facilityTypes };
